import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BFF_URL } from '../environments/environment';
import { take } from 'rxjs';
@Injectable({
	providedIn: 'root'
})
export class SubscriptionsService {
	private http = inject(HttpClient);

	serviceUrl = `${BFF_URL}/v1/shopify`;

	getAllSubscriptions(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			this.http.get<any>(`${this.serviceUrl}/subscriptions-by-user`)
				.pipe(take(1))
				.subscribe({
					next: (result) => resolve(result),
					error: (error) => reject(error)
				});
		});
	}
    getSubscriptionsByMdn(mdn:string): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			this.http.get<any>(`${this.serviceUrl}/subscriptions-by-user-mdn?mdn=${mdn}`)
				.pipe(take(1))
				.subscribe({
					next: (result) => resolve(result),
					error: (error) => reject(error)
				});
		});
	}
	getUserPayments(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			this.http.get<any>(`${this.serviceUrl}/payment-methods-by-user`)
				.pipe(take(1))
				.subscribe({
					next: (result) => resolve(result),
					error: (error) => reject(error)
				});
		});
	}
	updateSubscriptionPayment(contractId, paymentMethodId): Promise<any> {
		
		return new Promise<any>((resolve, reject) => {
			this.http.patch<any>(`${this.serviceUrl}/subscriptions/default-payment-method`, {contractId, paymentMethodId})
			  .pipe(take(1))
			  .subscribe({
				next: (result) => resolve(result),
				error: (error) => reject(error)
			  });
		  });
	}
	retryFailedPayment(contractId): Promise<any> {
		
		return new Promise<any>((resolve, reject) => {
			this.http.post<any>(`${this.serviceUrl}/subscriptions/retry-billing`, {contractId})
			  .pipe(take(1))
			  .subscribe({
				next: (result) => resolve(result),
				error: (error) => reject(error)
			  });
		  });
	}

	updateSubscriptionStatus(data): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			this.http.patch<any>(`${this.serviceUrl}/subscriptions/status`, data)
			  .pipe(take(1))
			  .subscribe({
				next: (result) => resolve(result),
				error: (error) => reject(error)
			  });
		  });
	}
}
